import type { CalendarGridColDef, CalendarGridRowData } from '../../CalendarGrid.model';

export type Value = NonNullable<CalendarGridRowData['attributes']>['securityTypeDisplayName'];

const securityTypeColDef: CalendarGridColDef<Value> = {
  field: 'attributes.securityTypeDisplayName',
  headerName: 'Security Type',
  type: 'text',
  filter: 'agSetColumnFilter',
  width: 110,
};

export default securityTypeColDef;
